import { render, staticRenderFns } from "./InstructionEdit.vue?vue&type=template&id=f8c723d2"
import script from "./InstructionEdit.vue?vue&type=script&lang=js"
export * from "./InstructionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports